<core-login
  #login
  [showQRLogin]="true"
  [enableCodeSignin]="true"
  [manualCodeLogin]="true"
  [enableGoogleSignin]="!environment.nativeApp"
  (loggedIn)="loggedIn()"
  [showPINLogin]="true"
  successLoginRedirect="/app"
  class="loginForm"
></core-login>
<a
  target="_blank"
  class="apkDownload"
  href="rs.emeni.dostava.apk"
  *ngIf="!environment.nativeApp && !login.isPinLoginActive"
>
  <span class="material-icons">android</span>
  <span class="label"><span class="lead">{{ 'login.downloadFor' | translate }}</span> <b>Android</b></span>
</a>
